import { membershipSettingsRestHooks } from '../store/MembershipSettings/MembershipSettingsSlice';

const useMembershipSettings = () => {
  const { loadMembershipSettings, updateMembershipSetting } =
    membershipSettingsRestHooks.use();

  const updateSetting = async (...params) => {
    await updateMembershipSetting(...params);
    loadMembershipSettings();
  };

  return {
    updateSetting,
  };
};

export default useMembershipSettings;
